module.exports = __webpack_public_path__ + "static/media/default-input.test.js.599fdd58.snap";